const dateFmt = new Intl.DateTimeFormat('th-TH', {
  timeZone: 'Asia/Bangkok',
  dateStyle: 'medium',
});

const dateTimeFmt = new Intl.DateTimeFormat('th-TH', {
  timeZone: 'Asia/Bangkok',
  dateStyle: 'medium',
  timeStyle: 'short',
});

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00Z` : iso);
  return Number.isNaN(d.getTime()) ? '—' : dateFmt.format(d);
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : dateTimeFmt.format(d);
}

/** เงินเก็บเป็นสตางค์ แสดงผลเป็นบาท */
export function formatSatang(satang: number | null | undefined): string {
  if (satang === null || satang === undefined) return '—';
  return `${(satang / 100).toLocaleString('th-TH', { minimumFractionDigits: 2 })} บาท`;
}

export function formatBahtShort(satang: number): string {
  return (satang / 100).toLocaleString('th-TH');
}

/** แปลงข้อความที่ผู้ใช้พิมพ์ (บาท) เป็นสตางค์ */
export function bahtTextToSatang(text: string): number | null {
  const cleaned = text.replace(/[^\d.]/g, '');
  if (!cleaned) return null;
  const baht = Number(cleaned);
  if (!Number.isFinite(baht) || baht <= 0) return null;
  return Math.round(baht * 100);
}

/** วันเวลาปัจจุบันในรูปแบบที่ input[type=datetime-local] ใช้ (เวลาไทย) */
export function nowLocalInput(): string {
  return new Date(Date.now() + 7 * 3600_000).toISOString().slice(0, 16);
}

/** แปลงค่าจาก datetime-local (เวลาไทย) กลับเป็น ISO UTC */
export function localInputToIso(value: string): string {
  return new Date(`${value}:00+07:00`).toISOString();
}
